// import homeData from '../../constants/home.json';

export const initialState = {};

const home = (state = initialState) => state;

export default home;
